/* global room_data TimelineLite TweenLite ajax_obj obj_file mtl_file Power1 */
var THREE = (typeof window !== "undefined" ? window['THREE'] : typeof global !== "undefined" ? global['THREE'] : null);
var SVG = require('svg.js');
require('../three/pan-controls');
require('three/examples/js/loaders/OBJLoader');
require('three/examples/js/loaders/MTLLoader');
//require('three/examples/js/loaders/GLTFLoader');
//require('three/examples/js/controls/OrbitControls');
//require('three/examples/js/effects/OutlineEffect');
require('three/examples/js/postprocessing/EffectComposer');
require('three/examples/js/postprocessing/RenderPass');
require('three/examples/js/postprocessing/ShaderPass');
//require('three/examples/js/postprocessing/OutlinePass');
require('three/examples/js/shaders/CopyShader');
const castShadows = false;

/*
const shadowObjects = [
    'sides',
    'door',
    'door_1',
    'Side_02_2',
    'Side_01_6',
    'Bottom_5',
    'Top_3',
    'Horizontal_01',
    'Horizontal_02',
    'Horizontal_03',
    'Horizontal_04',
    'Vertical_01',
    'Vertical_02',
    'Vertical_03',
];*/
const recieveShadows = [
    '1st_left_inner_wall',
    '2nd_left_inner_wall',
    'Far_left_wall',
    'Plane_LR',
    'Cube.12',
    //'Back_wall',
    'Back_wall.1',
    'Back_wall.2',
    'Back_wall.3',
    'Cube.14',
    'Cube.16',
    'Cube.6_5',
];
const backButton = document.querySelector('.go-back');
const buttons = document.querySelector('.buttons');
var loaded = false;
const defaultAskew =  {
    x: 0,
    y: 20,
    z: 80,
    rotx: -0.5,
    roty: 0,
    rotz: 0,
};

const askewMod = 
{
    x: 0,
    y: 20,
    z: 80,
    rotx: -0.5,
    roty: 0,
    rotz: 0,
};

const markerPosition = {
    offsetx: -100,
    offsety: 100,
    heightlevel: -1,
    boxpointer: -1,
}

const storedPosition = {
    x:0,
    y: 0,
    z:0,
}

let tempPointerPosition = {
    x:0,
    y: 0,
    z:0,
}

let controllerx
let controllery
let controllerz
let controllerrotx
let controllerroty
let controllerrotz
let markerx
let markery
let selected;
let markerpos;
//let boxpointer;
let dat;
let gui;
if(location.search === '?editor' || location.search == '?lights'){
    
    dat = require('dat.gui');
    gui = new dat.GUI();
    if(location.search === '?editor'){
        controllerx = gui.add(askewMod, 'x', -120, 120);
        controllery = gui.add(askewMod, 'y', -120, 120);
        controllerz = gui.add(askewMod, 'z', -40, 220);
        controllerrotx = gui.add(askewMod, 'rotx', -2, 2);
        controllerroty = gui.add(askewMod, 'roty', -2, 2);
        controllerrotz = gui.add(askewMod, 'rotz', -2, 2);
        markerx = gui.add(markerPosition, 'offsetx', -200, 200);
        markery = gui.add(markerPosition, 'offsety', -200, 200);
        markerpos = gui.add(markerPosition, 'heightlevel', -1, 3, 1);
        //boxpointer = gui.add(markerPosition, 'boxpointer', -1, 1, 1);
        let saveSelected = '';
        var save = { save:function(){ 
            return;
            fetch(ajax_obj.ajax_url+"?action=save_position", 
                {"body":JSON.stringify({
                    post_id,
                    askewMod,
                    markerPosition,
                    pointerPosition:tempPointerPosition,
                    saveSelected,
                }), "method":"POST"}).then(function(){
                location.reload();
            });

        }, selected: ''};
        selected = gui.add(save, 'selected');
        gui.add(save, 'save');
        selected.onChange((value) => {
            saveSelected = value;
        });
    }
    
}

const walls = [
    '1st_left_inner_wall',
    //'1st_left_inner_wall.1',
    '2nd_left_inner_wall',
    '1st_left_inner_wall.2',
    //'Plane_LR'
    //'Cube.14',
    //'Cube.15',
    //'Cube.16',
    //'Cube.6_5',
];

let zoomed = false;
let markersReady = false;
let markerColour;
let markers;
let additional = [];
if(typeof room_data != 'undefined'){
    markers = room_data.markers;
    markerColour = room_data.colour;
    Object.keys(markers).forEach(key => {
        const item = markers[key];
        if(typeof item.additional !== 'undefined'){
            additional = [...additional, ...item.additional];
        }
    });
}


/*
fetch('/wp-content/themes/titon/assets/3d/'+room+'/room.json').
then((response) => {
    return response.json();
}).then((data) => {
    markers = data.markers;
    markerColour = data.colour;
    contentIframe.style.borderColor = markerColour;
});
*/

const TitonHouse = function (element) {
    const that = this;
    this.renderer = null;
    this.canvas = element;
    this.aspectRatio = 1;
    this.highlights = [];
    this.markers = [];
    this.recalcAspectRatio();
    this.scene = null;
    this.savedPoint1 = null;
    this.savedPoint2 = null;
    this.savedMarker = null;
    //390
    this.cameraDefaults = {
        posCamera: new THREE.Vector3( -1100, 110, 600 ),
        posCameraTarget: new THREE.Vector3(0, 0, 0),
        near: 0.1,
        far: 10000,
        fov: 53,
    };
    this.camera = null;
    this.cameraTarget = this.cameraDefaults.posCameraTarget;

    this.controls = null;
    
    this.raycaster = new THREE.Raycaster();
    
    // postprocessing
    this.composer = null;

    this.frustum = new THREE.Frustum()

    this.mouse = new THREE.Vector2(2, 2);
    this.screen = new THREE.Vector2(0, 0);
    this.currentlyIntersected = null;

    this.tooltip = document.querySelector('.overlay');
    this.tooltipText = document.querySelector('.overlay-text');

    this.phongMaterial;

    this.qtip = $(element).qtip({
        content: {
            text: '',
            button: true,
        },
        hide: {
            event: false,
        },
        position: {
            target: [100, 200],
            my: 'right top',
            container: $(element.parentNode),
            adjust: {
                method: 'flip',
            },
        },
        style: {
            width: false, // No set width
            height: false, // No set height
            tip: { // Requires Tips plugin
                width: 25, 
                height: 50,
                border: true,
                //corner: 'top left',
            },
        },
        show: { event: false, ready: false },
        events: {
            hide: function() {
                that.resetCamera();
                that.controls.enabled = true;
            },
        },
    });

    this.qtipapi = this.qtip.qtip('api');

    const testAskew = function(){
        const position = Object.assign({}, storedPosition);
        position.x += askewMod.x;
        position.y += askewMod.y;
        position.z += askewMod.z;
        position.rotx = 0 + askewMod.rotx;
        position.roty = 0 + askewMod.roty;
        position.rotz = 0 + askewMod.rotz;
        that.camera.position.set(position.x, position.y, position.z);
        that.camera.rotation.set(position.rotx, position.roty, position.rotz);
        //cube.position.set(test.x, test.y, test.z);
    }
    if(location.search === '?editor'){
        controllerx.onChange(testAskew);
        controllery.onChange(testAskew);
        controllerz.onChange(testAskew);
        controllerrotx.onChange(testAskew);
        controllerroty.onChange(testAskew);
        controllerrotz.onChange(testAskew);
        markerx.onChange(function() {
            //disable change
            return;
            if(save.selected){
                markers[save.selected].offsetx = markerPosition.offsetx;
                markers[save.selected].offsety = markerPosition.offsety;
                that.markers.forEach((markerObject, key) => {
                    if(markerObject.mesh.name === save.selected){
                        const mesh = markerObject.mesh;
                        that.markers[key].marker.parentNode.removeChild(that.markers[key].marker);
                        that.markers[key] = that.drawMarker(save.selected);
                        that.markers[key].mesh = mesh;
                    }
                });
            }
        });
        markery.onChange(function() {
            //disable change
            return;
            if(save.selected){
                markers[save.selected].offsetx = markerPosition.offsetx;
                markers[save.selected].offsety = markerPosition.offsety;
                that.markers.forEach((markerObject, key) => {
                    if(markerObject.mesh.name === save.selected){
                        const mesh = markerObject.mesh;
                        that.markers[key].marker.parentNode.removeChild(that.markers[key].marker);
                        that.markers[key] = that.drawMarker(save.selected);
                        that.markers[key].mesh = mesh;
                    }
                });
            }
        })
    }


    this.tweenCamera = function(position, pointAt = false, marker = {}){
        this.savedPoint1 = position;
        this.savedPoint2 = pointAt;
        this.savedMarker = marker;
        const that = this;

        let {askew, boxpointer} = marker;
        
        const original = position.clone();

        if (!pointAt){
            pointAt = that.cameraDefaults.posCameraTarget;
        }
        
        const from = {
            x : this.camera.position.x,
            y : this.camera.position.y,
            z : this.camera.position.z,
            rotx : this.camera.rotation.x,
            roty : this.camera.rotation.y,
            rotz : this.camera.rotation.z,
            lx: this.cameraTarget.x,
            ly: this.cameraTarget.y,
            lz: this.cameraTarget.z,
        };
        storedPosition.x = position.x;
        storedPosition.y = position.y;
        storedPosition.z = position.z;
        if (askew){
            if(window.innerWidth < 420){
                position.z += 40;
                position.x += 5;
                position.y += 10;
            } else {
                position.z += askew.z;
                position.y += askew.y;
                position.x += askew.x;
                if(window.innerWidth < 690){
                    position.x -= 20;
                }
            }
            if(location.search === '?editor'){
                controllerx.setValue(askew.x);
                controllery.setValue(askew.y);
                controllerz.setValue(askew.z);
                controllerrotx.setValue(askew.rotx);
                controllerroty.setValue(askew.roty);
                controllerrotz.setValue(askew.rotz);
            }
        }
        
        const to = {
            x : position.x,
            y : position.y,
            z : position.z,
            rotx : 0,
            roty : 0,
            rotz : 0,
            lx: pointAt.x,
            ly: pointAt.y,
            lz: pointAt.z,
            ease:Power1.easeInOut,
            onUpdate() {
                that.camera.position.set(from.x, from.y, from.z);
                //if (askew){
                //that.camera.lookAt(pointAt);
                //} else {
                that.camera.rotation.set(from.rotx, from.roty, from.rotz);
                if(typeof that.qtipapi !== 'undefined' && that.qtipapi.tooltip){
                    that.qtipapi.tooltip.removeClass('show');
                }
                if(askew){
                    let contentPos = that.vectorToScreen(original.clone(), that.camera);
                    const {width, height} = that.renderer.getContext().canvas;

                    const middleWidth = 0.5 * width;
                    const middleHeight = 0.5 * height;
                    let tipPoint = '';
                    if(contentPos.x > middleWidth){
                        tipPoint += 'right ';
                    } else {
                        tipPoint += 'left ';
                    }
                    if(contentPos.y > middleHeight){
                        tipPoint += 'bottom';
                    } else {
                        tipPoint += 'top';
                    }
                    if(typeof boxpointer != 'undefined' && boxpointer == 1){
                        tipPoint = tipPoint.replace(/([^ ]*) ([^ ]*)/, "$2 $1");
                    }
                    if(window.innerWidth < 420){
                        tipPoint = 'bottom left';
                    }
                    that.qtipapi.set({
                        'position.target': [contentPos.x, contentPos.y],
                    });
                    if(that.qtipapi.get('position.my') != tipPoint){
                        that.qtipapi.tooltip.removeClass('qtip-pos-br qtip-pos-bl qtip-pos-tr qtip-pos-tl qtip-pos-rb qtip-pos-lb qtip-pos-rt qtip-pos-lt');
                        that.qtipapi.set({
                            'position.my': tipPoint,
                        });
                    }

                }
                //}
            },
            onComplete() {
                //if (askew){
                //that.camera.lookAt(pointAt);
                //} else {
                setTimeout(() => {
                    if(typeof that.qtipapi !== 'undefined' && that.qtipapi.tooltip){
                        that.qtipapi.tooltip.toggleClass('show', askew);
                    }
                }, askew ? 366 : 333);
                that.camera.rotation.set(from.rotx, from.roty, from.rotz);
                markersReady = false;
                if(askew){
                    setTimeout(() => {
                        const contentPos = that.vectorToScreen(original.clone(), that.camera);
                        const {width, height} = that.renderer.getContext().canvas;

                        const middleWidth = 0.5 * width;
                        const middleHeight = 0.5 * height;
                        let tipPoint = '';
                        if(contentPos.x > middleWidth){
                            tipPoint += 'right ';
                        } else {
                            tipPoint += 'left ';
                        }
                        if(contentPos.y > middleHeight){
                            tipPoint += 'bottom';
                        } else {
                            tipPoint += 'top';
                        }
                        if(typeof boxpointer != 'undefined' && boxpointer == 1){
                            tipPoint = tipPoint.replace(/([^ ]*) ([^ ]*)/, "$2 $1");
                        }
                        if(window.innerWidth < 420){
                            tipPoint = 'bottom left';
                        }
                        that.qtipapi.set({
                            'position.target': [contentPos.x, contentPos.y],
                        });
                        if(that.qtipapi.get('position.my') != tipPoint){
                            that.qtipapi.tooltip.removeClass('qtip-pos-br qtip-pos-bl qtip-pos-tr qtip-pos-tl qtip-pos-rb qtip-pos-lb qtip-pos-rt qtip-pos-lt');
                            that.qtipapi.set({
                                'position.my': tipPoint,
                            });
                        }
                    }, 333);
                }
                //}
                //that.cameraTarget = new THREE.Vector3(from.lx,from.ly,from.lz);
            },
        };

        if (askew){
            to.rotx += askew.rotx;
            to.roty += askew.roty;
            to.rotz += askew.rotz;
        }

        if(window.innerWidth < 420){
            to.rotx = 0;
            to.roty = 0;
            to.rotz = 0;
        }

        const tl = new TimelineLite();
        tl.add( TweenLite.to(from, 1, to) );

        if (askew){
            //tl.add( TweenLite.set(contentIframe, {width: 10, height:0}) );
            //tl.add( TweenLite.to(contentIframe, 2, {width: 10, height: 200}) );
            //tl.add( TweenLite.to(contentIframe, 2, {width: 200, height: 200}) );
        }
    };
    if(backButton){
        backButton.addEventListener('click', () => {
            this.resetCamera();
            this.controls.enabled = true;
            backButton.classList.remove('active');
            //.setAttribute('src', '');
            
        });
    }

    /*
    this.canvas.addEventListener('click', () => {
        if (this.highlights.length === 0){
            return;
        }
        this.raycaster.setFromCamera(this.mouse, this.camera);
    
        const intersects = this.raycaster.intersectObjects(this.highlights);
        console.log(intersects);
        
        if (intersects.length > 0) {
            //const point = this.getCenterPoint(intersects[0].object);
            const pointonScreen = this.toScreenPosition(intersects[0].object, this.camera);
            console.log(pointonScreen);
            //backButton.classList.add('active');
            //contentIframe.classList.add('active');
            //contentIframe.setAttribute('src', 'https://en.wikipedia.org/wiki/Special:Random');
            //this.tweenCamera(point, point, true);
            
            //console.log(point);
        }
    });
    */
};
  

TitonHouse.prototype = {
    constructor: TitonHouse,
    lights: 0,
    addLight(x, y, z, intensity = .6, distance=0, castShadow = false) {
        const spotlight = new THREE.PointLight(0xffffff, intensity, distance, 2);
        spotlight.position.set(x, y, z);
        spotlight.castShadow = castShadow;
                    
        spotlight.shadow.radius = 0.3;
        spotlight.shadow.mapSize.width = 2000;
        spotlight.shadow.mapSize.height = 2000;
        spotlight.shadow.camera.near = 0.1;
        spotlight.shadow.camera.far = 10000;
        


        this.scene.add(spotlight);
        this.lights++;        
        if(location.search == '?lights'){
            var geometry = new THREE.BoxGeometry( 5, 5, 5 );
            var material = new THREE.MeshLambertMaterial( {color: 0xff0000} );
            var cube = new THREE.Mesh( geometry, material );
            cube.castShadow = false;
            cube.position.set(x, y, z);
            this.scene.add(cube);
            const test = {};
            test.x = x;
            test.y = y;
            test.z = z;
            test.intensity = intensity;
            test.distance = distance
            const controllerx = gui.add(test, 'x', -1500, 1500).name(this.lights+' : x');
            const controllery = gui.add(test, 'y', -1500, 1500).name(this.lights+' : y');
            const controllerz = gui.add(test, 'z', -200, 1500).name(this.lights+' : z');
            const controlleri = gui.add(test, 'intensity', 0, 1).name(this.lights+' : intensity');
            const controllerd = gui.add(test, 'distance', 0, 10000).name(this.lights+' : distance');

            controllerx.onChange(function() {
                spotlight.position.set(test.x, test.y, test.z);
                cube.position.set(test.x, test.y, test.z);
            });
            controllery.onChange(function() {
                spotlight.position.set(test.x, test.y, test.z);
                cube.position.set(test.x, test.y, test.z);
            });
            controllerz.onChange(function() {
                spotlight.position.set(test.x, test.y, test.z);
                cube.position.set(test.x, test.y, test.z);
            });
            controlleri.onChange(function() {
                spotlight.intensity = test.intensity;
            });
            controllerd.onChange(function() {
                spotlight.distance = test.distance;
            });
        }
        
    },
    initGL () {
        this.renderer = new THREE.WebGLRenderer({
            canvas: this.canvas,
            antialias: true,
            autoClear: true,
        });
        this.canvas.parentNode.classList.add('loading');
        this.composer = new THREE.EffectComposer( this.renderer );
        
        this.renderer.setClearColor(0x050505);
        this.renderer.shadowMap.enabled = true;
        this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;

        this.scene = new THREE.Scene();
        this.scene.background = new THREE.Color(0xf0f0f0);
        //this.scene.fog = new THREE.FogExp2( 0xffffff, 0.0003 );
        this.camera = new THREE.PerspectiveCamera(
            this.cameraDefaults.fov,
            this.aspectRatio,
            this.cameraDefaults.near,
            this.cameraDefaults.far
        );

        

        this.walls = [];
        /*
        new THREE.OrbitControls( this.camera, this.renderer.domElement );
        setInterval(() => {
            console.log(this.camera.position);
        }, 500);*/

        const renderPass = new THREE.RenderPass( this.scene, this.camera );
        //const fxaaPass = new THREE.ShaderPass( THREE.FXAAShader );
        this.composer.addPass( renderPass );
        //this.composer.addPass( fxaaPass );

        /*
        const resolution = new THREE.Vector2( window.innerWidth, window.innerHeight );
        this.outlinePass = new THREE.OutlinePass( resolution, this.scene, this.camera );
        this.outlinePass.edgeStrength = 3;
        this.outlinePass.edgeGlow = 0.5;
        this.outlinePass.visibleEdgeColor.set(0xba2334); 
        this.outlinePass.renderToScreen = true;
        this.composer.addPass( this.outlinePass );
        */
        this.resetCamera();
    
        this.controls = new THREE.PanControls(this.camera, this.renderer.domElement);

        //this.controls = new THREE.OrbitControls( this.camera );

        if(location.search === '?flattest') {
        //this.addLight(-1274, 89, 286, 1, 0, false);
        //this.addLight(-1107, 89, 900, .8, 0, false);
        //this.addLight(-941, 56, 211, .59, 775, false);
        //this.addLight(-808, 89, 60, .49, 1526, false);

            //this.addLight(-675, 56, 60, .47, 533, false);
            //this.addLight(-509, 56, 900, .3, 0, false);
            //this.addLight(-346, 56, 154, .5, 531, false);

            //this.addLight(-160, 155, 900, .4, 0, false);

            //this.addLight(-177, 155, 135, .76, 976, false);
            //this.addLight(185, 185, 900, .2, 0, false);

            //this.addLight(388, 152, 59, .9, 0, false);
            //this.addLight(616, 152, 900, .7, 976, false);
            //this.addLight(700, 152, 900, .7, 3634, false);
            //this.addLight(848, 155, 360, 1, 0, false);
            const light2 = new THREE.AmbientLight(0xffffff, .8);
            this.scene.add(light2);
            const light = new THREE.DirectionalLight( 0xffffff, .8 );
            light.position.set(new THREE.Vector3(0, 0, -1));
            this.scene.add(light);
        } else {
        
            const light = new THREE.AmbientLight(0xffffff, 0.75);
            this.scene.add(light);

        
            this.addLight(-1274, 155, 441, .43, 0, false);
            this.addLight(-1274, 693, 54, .14, 0, false);
            //this.addLight(-900, 89, 441, .1, 0, false);
            //this.addLight(-600, 89, 441, .1, 0, false);
            //this.addLight(-300, 89, 441, .1, 0, false);
            this.addLight(-108, 217, 147, .15, 7133, false);
            this.addLight(802, 130, 561, .30, 9253, false);

            //7
            //this.addLight(-642, 89, -53, .17, 201, false);
            //this.addLight(-509, 89, -15, .23, 312, false);
            //this.addLight(-346, 56, 154, .1, 531, false);
            //this.addLight(-410, 122, 154, .3, 1300, castShadows);

            //11
            //this.addLight(-177, 155, 173, .5, 1198, false);
            //this.addLight(-144, 288, 173, .2, 201, false);

            //this.addLight(-11, 56, -34, .27, 421, false);
            //this.addLight(185, 185, -147, .22, 421, false);
            //this.addLight(222, 56, 211, .35, 755, false);

            //this.addLight(384, 152, 59, .52, 976, false);
            //this.addLight(616, 152, -91, .59, 531, false);
            //this.addLight(820, 155, 305, .76, 533, false);
        
        }
        //this.addLight(-880, 50, -200, .05, false);
        //this.addLight(-460, 150, 0, .1);
        //this.addLight(-140, 200, 600, .02, false);
        //this.addLight(-140, 185, 257, 0.42, true);
        //this.addLight(152, 185, 884, .44, true);
        
    },

    drawMarker(name, pointerPosition = false){
        
        const that = this;
        const marker = document.createElement('div');

        marker.classList.add('marker');
        that.canvas.parentNode.appendChild(marker);
        let xoffset = markers[name].offsetx;
        let yoffset = markers[name].offsety;
        let heightlevel = markers[name].heightlevel;
        let product = markers[name].product;
        const askew = markers[name].askew ? markers[name].askew : defaultAskew;
        const boxpointer = markers[name].boxpointer ? markers[name].boxpointer : -1;
        const line = SVG(marker).size(30, 30);
        let startx = 17;
        let starty = 17;
        let endx = Math.abs(xoffset);
        let endy = Math.abs(yoffset);
        let midx = endx;
        let contentXOffset = 0;
        let contentYOffset = 0;
        const midy = endy/2;
        const inactiveLine = line.nested();
        const svgline = inactiveLine.line().stroke({ color: markerColour, width: 1 });
        const svgline2 = inactiveLine.line().stroke({ color: markerColour, width: 1 });

        /*
        if (yoffset > 0){
            yoffset -= 17;
            line.node.style.marginTop = `-${yoffset}px`;
            starty = yoffset;
            endy = 0;
        }
        let upside = false;
        
        if (xoffset > 0){
            xoffset -= 17;
            midx -= 17;
            line.node.style.marginLeft = `-${xoffset}px`;
            startx = xoffset;
            endx = 0;
        } else if(yoffset < 0){
            upside = true;
        }

        if (yoffset < 0 && xoffset < 0){
            contentYOffset -= 200 - 17;
        }

        if (yoffset > 0 && xoffset > 0){
            contentYOffset -= yoffset;
        }*/
        
        svgline.plot([[startx, starty], [midx, midy]]);
        svgline2.plot([[midx, midy], [endx, endy]]);
        var group = line.nested();
        var circle = group.circle(30).attr({ cx: startx, cy: starty }).stroke({ color: markerColour, width: 2 }).fill('#ffffff');
        var circleline1 = group.line().stroke({ color: markerColour, width: 1 }).plot([[startx, starty-5], [startx, starty+5]]);
        var circleline2 = group.line().stroke({ color: markerColour, width: 1 }).plot([[startx-5, starty], [startx+5, starty]])
        
        marker.addEventListener('mouseover', () =>{ 
            
            if(location.search === '?editor'){
                selected.setValue(name);                
                if(markerPosition.offsetx !== markers[name].offsetx){
                    markerx.setValue(markers[name].offsetx);
                }
                if(markerPosition.offsety !== markers[name].offsety){
                    markery.setValue(markers[name].offsety);
                }
                if(typeof markers[name].heightlevel != 'undefined'){
                    markerpos.setValue(markers[name].heightlevel);
                }  
                if(typeof markers[name].boxpointer != 'undefined'){
                    boxpointer.setValue(markers[name].boxpointer);
                }      
            }     
            that.controls.slowdown();        
                     
            circle.finish().animate(500, '>').attr({ fill: markerColour });
            circleline1.finish().animate(500, '>').stroke({ color: '#ffffff' });
            circleline2.finish().animate(500, '>').stroke({ color: '#ffffff' });
        });
        marker.addEventListener('mouseout', () =>{ 
            circle.finish().animate(500, '>').attr({ fill: '#ffffff' });
            circleline1.finish().animate(500, '>').stroke({ color: markerColour });
            circleline2.finish().animate(500, '>').stroke({ color: markerColour });
        })
        let track = false;
        if(typeof markers[name].track === 'string'){
            circle.hide();
            circleline1.hide();
            circleline2.hide();
            track = markers[name].track;
            that.canvas.parentNode.insertBefore(marker, that.canvas.parentNode.firstChild);
        }
        const markerobject = {name, marker, pointerPosition, line, xoffset, yoffset, askew, boxpointer, circle, group, inactiveLine, contentXOffset, contentYOffset, svgline, svgline2, heightlevel, track};
        markerobject.marker.addEventListener('mouseover', () => {
            console.log(name);
            console.log(markerobject.pointerPosition);
            tempPointerPosition = markerobject.pointerPosition.clone();
        });

        markerobject.marker.addEventListener('click', (event) => {
            const myMarker = event.currentTarget;
            if(!myMarker.classList.contains('show')){
                return;
            }
            event.preventDefault();
            marker.classList.toggle('active');
            if(marker.classList.contains('active') && zoomed === false){
                zoomed = true;
                markerobject.group.hide();
                markerobject.inactiveLine.hide();
                that.cameraDefaults.posCamera = that.camera.position.clone();
                that.controls.enabled = false;
                that.controls.pause();
                if(backButton){
                    backButton.classList.add('active');
                }
                const point = that.getCenterPoint(markerobject.mesh, markerobject.pointerPosition);
                console.log(markerobject);
                that.tweenCamera(point, point, markerobject);
                that.canvas.parentNode.classList.add('focus');
                //contentIframe.setAttribute('src',ajax_obj.ajax_url+'?action=view_product&product='+encodeURIComponent(product));
                that.qtipapi.show();
                that.qtipapi.set({
                    'content.text': '<iframe src="'+ajax_obj.ajax_url+'?action=view_product&product='+encodeURIComponent(product)+'&colour='+encodeURIComponent(markerColour)+'" height="100%" width="100%"></iframe>',
                });
                const iframe = that.qtipapi.tooltip.find('iframe');
                iframe.one('load', (event) => {
                    const height = event.currentTarget.contentWindow.document.body.querySelector('.info').offsetHeight + 20;
                    if(height > 260){
                        that.qtipapi.tooltip.css({maxHeight:height+'px'});
                    }
                });
                //contentIframe.contentWindow.document.body.innerHTML = markerobject.iframe;
            } else if(zoomed === true) {
                markerobject.group.show();
                markerobject.inactiveLine.show();
                
                that.resetCamera();
                that.controls.enabled = true;
                if(backButton){
                    backButton.classList.remove('active');
                }
                //contentIframe.removeAttribute('src');
                that.qtipapi.hide();
                that.qtipapi.set({
                    'content.text': '',
                });
            }
        });
        return markerobject;
    },
    

    initContent () {
        const that = this;        
        const objectLoader = new THREE.OBJLoader();
        //const gltfloader = new THREE.GLTFLoader();
        const callbackOnLoad = function (event) {
            let usedObjectMarkers = [];
            that.canvas.parentNode.classList.remove('loading');
            buttons.classList.remove('hidden');
            that.tooltip.style.visibility = 'hidden';
            //const defaultMaterial = new THREE.MeshPhongMaterial({ color: 0xaaaaaa, shininess: 10 });
            const trackerArray = {};
            let count =0;
            event.traverse( function ( child ) {
                if ( child.isMesh ) {

                    count++;

                    child.renderOrder = 1000 - count;

                    let doNotSelect = true;
                    //const isGlass = child.name.startsWith('Glass_inner') || child.name.startsWith('glass') || child.name.startsWith('Glass')
                    //doNotSelect = /^(Plane|Back_wall)/.test(child.name);
                    
                    
                    //child.material = defaultMaterial;
                    //child.material.map = defaultMaterial.map;
                    //child.material.specular = defaultMaterial.specular;
                    //child.material = new THREE.MeshPhongMaterial({ color: child.material.color, map: child.material.map });
                    
                    if(child.name == 'Sofa'||child.name == 'Back_Pillow_02'||child.name == 'Seat_Right'||child.name == 'Arm_Rest'||child.name=='Cube.4'){
                        //child.material = defaultMaterial;
                    }

                    if(child.name == 'Arm_Rest'||child.name == 'Counter'){
                        //hild.material = new THREE.MeshLambertMaterial({ color: child.material.color });
                        child.visible = true;
                    }

                    if(child.name == 'Bedframe'){
                        child.material.shininess = 0;
                    }
                    
                  
                    if (Object.keys(markers).indexOf(child.name) === -1){
                        //child.material = defaultMaterial;
                        //child.material = new THREE.MeshLambertMaterial({ color: 0xeeeeee });
                    }
                    if (!doNotSelect){
                        that.highlights.push(child);
                    }
                    //console.log(child.name);
                    //if(/^Solid2/.test(child.name)){
                    //console.log(child.name);
                    //console.log(Object.keys(markers).indexOf(child.name));
                    //}
                    if (additional.indexOf(child.name) !== -1){
                        //child.material = new THREE.MeshLambertMaterial({ color: markerColour });
                    }
                    if (Object.keys(markers).indexOf(child.name) !== -1){
                        usedObjectMarkers.push(child.name);
                        //child.material = new THREE.MeshLambertMaterial({ color: markerColour });
                        
                        /*
                        const iframe = `
                        <h1>${child.name}</h1>
                        <p>Configuration</p>
                        <code>
                        ${JSON.stringify(markers[child.name], null, 2)}
                        </code>
                        `;
                        */
                        
                        const markerobject = that.drawMarker(child.name, markers[child.name].pointerPosition);
                        if(markerobject.track){
                            trackerArray[markerobject.track] = markerobject.name;
                        }
                        markerobject.mesh = child;
                        markerobject.pointerPosition = that.getCenterPoint(child, markers[child.name].pointerPosition);
                        that.markers.push(markerobject);
                        
                    }
                        
                    child.receiveShadow = (castShadows && recieveShadows.indexOf(child.name) !== -1);
                    //child.castShadow = (castShadows && shadowObjects.indexOf(child.name) !== -1);
                    child.castShadow = castShadows;

                    if(walls.indexOf(child.name) !== -1){
                        child.castShadow = false;
                        child.receiveShadow = true;
                        that.walls.push(child);
                    }

                    if(child.name.startsWith("Window_espay_standard_600mm_hotspot")){
                        child.position.z += 1;
                    }

                    if(child.name === 'airer' || child.name === 'Oven_and_Hob'){
                        const originalMaterial = child.material.clone();
                        child.material = new THREE.MeshPhongMaterial(
                            {color: originalMaterial.color,
                                specular: originalMaterial.specular,
                                shading: THREE.FlatShading });
                    }
                    child.onAfterRender = function() {
                        if(that.controls.firstrun === false){
                            that.controls.firstrun = true;
                            that.controls.resume(100, 0);
                        }
                    }
                }
            });

            Object.keys(trackerArray).forEach(key => {
                const value = trackerArray[key];
                that.markers.forEach((marker) => {
                    if(marker.name === key){
                        marker.trackedby = value;
                    }
                });
            });


            that.scene.add(...event.children);
            //that.controls.play();
            Object.keys(markers).forEach(name => {
                if(usedObjectMarkers.indexOf(name) === -1){
                    if(typeof markers[name].pointerPosition == 'object'){
                        const markerobject = that.drawMarker(name, markers[name].pointerPosition);
                        markerobject.mesh = null;
                        markerobject.pointerPosition = markers[name].pointerPosition;
                        that.markers.push(markerobject);
                    } else {
                        console.log(name+' is orphaned!');  
                        console.log(markers[name]);
                    }
                }
            });
        };
        const callbackProgress = function(xhr){
            const req = xhr.target;
            that.tooltip.style.visibility = 'visible';
            let progressText = `Loading...`;
            //let progressAvailable = false;
            if (xhr.lengthComputable) {
                progressText = `${Math.round( xhr.loaded / xhr.total * 100 )}% loaded`;
            } else {
                var total = req.getResponseHeader('content-length')
                var encoding = req.getResponseHeader('content-encoding')
                if (total && encoding && (encoding.indexOf('gzip') > -1)) {
                    // assuming average gzip compression ratio to be 25%
                    total *= 4 // original size / compressed size
                    progressText = `${Math.round( Math.min(100, xhr.loaded / total * 100) )}% loaded`;
                }
            }
              
            that.tooltipText.innerHTML = progressText;
            if (xhr.loaded === xhr.total && !loaded){
                loaded = true;
                //that.tooltip.innerHTML = 'Building room...';
                that.tooltip.style.visibility = 'hidden';
            }
        };
        /*
        if(location.search === '?gltftest') {
            gltfloader.load(
                // resource URL
                '/wp-content/themes/titon/baked/Gltf/Roomset-Hardware-texture test-2.gltf',
                // called when the resource is loaded
                function ( gltf ) {
                    that.canvas.parentNode.classList.remove('loading');
                    buttons.classList.remove('hidden');
                    that.tooltip.style.visibility = 'hidden';
                    that.scene.add( gltf.scene );
                    
                    console.log(gltf.animations); // Array<THREE.AnimationClip>
                    console.log(gltf.scene); // THREE.Scene
                    console.log(gltf.scenes); // Array<THREE.Scene>
                    console.log(gltf.cameras); // Array<THREE.Camera>
                    console.log(gltf.asset); // Object
            
                },
                callbackProgress, null
            );
            */
        //} else {
        
        new THREE.MTLLoader()
            .load( mtl_file, function ( materials ) {

                materials.preload();

                objectLoader
                    .setMaterials( materials )
                    .load(obj_file, callbackOnLoad, callbackProgress, null);

            } );
        //}
    },

    getCenterPoint(mesh, pointerPosition = false) {
        if(pointerPosition){
            return new THREE.Vector3(pointerPosition.x, pointerPosition.y, pointerPosition.z);
        }
        const middle = new THREE.Vector3();
        const {geometry} = mesh;

        geometry.computeBoundingBox();

        middle.x = (geometry.boundingBox.max.x + geometry.boundingBox.min.x) / 2;
        middle.y = (geometry.boundingBox.max.y + geometry.boundingBox.min.y) / 2;
        middle.z = (geometry.boundingBox.max.z + geometry.boundingBox.min.z) / 2;

        mesh.localToWorld( middle );
        return middle;
    },

    resizeDisplayGL () {
        const width = window.innerWidth;
        const height = window.innerHeight;
        this.aspectRatio= width / height;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize( width, height );
        this.composer.setSize( width, height );
        markersReady = false;
        this.resetCamera();
        this.qtipapi.hide();
        this.controls.enabled = true;
    },

    recalcAspectRatio () {
        this.aspectRatio = (this.canvas.offsetHeight === 0) ? 1 : this.canvas.offsetWidth / this.canvas.offsetHeight;
    },

    resetCamera () {
        zoomed = false;
        this.tweenCamera(this.cameraDefaults.posCamera, this.cameraDefaults.posCameraTarget);
        this.canvas.parentNode.classList.remove('focus');
        const activeMarkers = this.canvas.parentNode.querySelectorAll('.marker.active');
        activeMarkers.forEach(activeMarker => {
            activeMarker.classList.remove('active');
        });
        this.markers.forEach((markerObject) => {
            markerObject.group.show();
            markerObject.inactiveLine.show();
        });
        this.updateCamera();
        if(this.controls){
            this.controls.resume();
        }
    },

    updateCamera () {
        this.camera.aspect = this.aspectRatio;
        //this.camera.lookAt(this.cameraTarget);
        this.camera.updateProjectionMatrix();
    },

    setMarkers(){
        const that = this;
        if(markersReady && (zoomed || !that.controls.moving)){
            return;
        }
        if(this.markers.length > 0){
            markersReady = true;
        }
        this.markers.forEach(data => {
            /*
             < -730 : living room
             - 220 kitchen
             - 40 cuboard
             320 : bathroom
             690: bedroom
            */
            const meshPosition = that.getCenterPoint(data.mesh, data.pointerPosition).x;
            const cameraPosition = that.camera.position.x;
            let skip = false;
            //console.log(cameraPosition);
            if(cameraPosition < -1100){
                //glass door
                if(meshPosition >= -1180){
                    skip = true;
                }
            } else if(cameraPosition >= -1100 && cameraPosition < -730){
                //in living room
                if(meshPosition < -1180 || meshPosition >= -730){
                    skip = true;
                }
            }
            else if(cameraPosition >= -730 && cameraPosition < -220){
                //in kitchen
                if(meshPosition < -720 || meshPosition >= -220){
                    skip = true;
                }
            }
            else if(cameraPosition >= -220 && cameraPosition < -40){
                //in cupboard
                if(meshPosition < -220 || meshPosition >= -40){
                    skip = true;
                }
            }
            else if(cameraPosition >= -40 && cameraPosition < 320){
                //in bathroom
                if(meshPosition < -40 || meshPosition >= 320){
                    skip = true;
                }
            }
            else if(cameraPosition >= 320 && cameraPosition < 690){
                //in bedroom
                if(meshPosition < 320 || meshPosition >= 690){
                    skip = true;
                }
            } else if(cameraPosition >= 690) {
                //in front door
                if(meshPosition < 690){
                    skip = true;
                }
            }           

            if(skip){
                data.marker.classList.remove('show');
                return;
            }
            let tracked = false;
            if(data.track){
                that.markers.forEach(totrack=> {
                    if(totrack.name === data.track){
                        tracked = totrack;
                        data.heightlevel = totrack.heightlevel;
                        data.xoffset = totrack.xoffset;
                    }
                });
            }
            const newPosition = that.toScreenPosition(data.mesh, data.pointerPosition, that.camera);
            //const trackedPosition = tracked ? that.toScreenPosition(tracked.mesh, tracked.pointerPosition, that.camera) : false;
            //const center = this.getCenterPoint(data.mesh, data.pointerPosition);
            /*
            if(data.mesh.name == 'Friction_hinge_top_hotspot.1_1'){
                console.log(newPosition);
                console.log(that.camera.position);
                console.log(new THREE.Vector2(newPosition.vectorx,0));
            }
            */

            if(newPosition.vectorx > 0.8 || newPosition.vectorx < -0.8){
                data.marker.classList.remove('show');
                return;
            }
            data.marker.classList.add('show');
            
            //that.raycaster.setFromCamera(newPosition, that.camera);
            /*
            if(center.y < 260 && center.z < 90){
                that.raycaster.setFromCamera(new THREE.Vector2(newPosition.vectorx, newPosition.vectory), that.camera);
                const intersects = that.raycaster.intersectObjects(that.walls);
                if(data.mesh.name == 'Friction_hinge_top_hotspot.1_1'){
                    //console.log(intersects);
                    console.log(intersects);
                    const newInter = [];
                    data.mesh.raycast(that.raycaster,newInter);
                    console.log(newInter);
                    
                }
                //let objectsIntersect = 0;
                if(intersects.length > 0){
                    data.marker.classList.remove('show');
                    return;
                } else {
                    data.marker.classList.add('show');
                }
            }
            */

            /*
            if (newPosition.vectorx < -1 || newPosition.vectorx> 1 || objectsIntersect > 1){
                data.marker.style.display = 'none';
            } else {
                data.marker.style.display = 'block';
            }
            */
            //data.marker.style.left = `${newPosition.x}px`;
            
            const height = this.canvas.offsetHeight;
            const heights = [
                height/5,
                (height/5)*2,
                (height/5)*3,
                (height/5)*4,
            ];

            let closesty = heights.reduce((prev, curr) => {
                return (Math.abs(curr - newPosition.y) > 50 && Math.abs(curr - newPosition.y) < Math.abs(prev - newPosition.y)) ? curr : prev;
            });

            if(typeof data.heightlevel !== 'undefined' && typeof heights[data.heightlevel] !== 'undefined'){
                closesty = heights[data.heightlevel];
            }

            data.marker.style.top = tracked ? tracked.marker.style.top : `${closesty}px`;
            let xoffset = data.xoffset;
            let yoffset = newPosition.y-closesty;
            let midway = false;
            if(data.trackedby){
                that.markers.forEach(totrackby=> {
                    if(totrackby.name === data.trackedby){
                        const trackedByPosition = that.toScreenPosition(totrackby.mesh, totrackby.pointerPosition, that.camera);
                        if(newPosition.x < trackedByPosition.x && (trackedByPosition.x - newPosition.x) > 30){
                            midway = newPosition.x + ((trackedByPosition.x - newPosition.x) / 2);  
                        }
                        if(newPosition.x > trackedByPosition.x && (newPosition.x - trackedByPosition.x) > 30){
                            midway = trackedByPosition.x + ((newPosition.x - trackedByPosition.x) / 2); 
                        }
                    }
                });
            }
            //data.line.size(100, Math.abs(yoffset));
            const pointRight = xoffset < 0;
            const pointUp = closesty > newPosition.y;
            const pointerdiff = 100;
            if(tracked){
                //const midway = trackedPosition.x + (newPosition.x - trackedPosition.x) / 2;
                //tracked.marker.style.left = midway+'px';
                data.marker.style.left = tracked.marker.style.left;
            } else if(midway) {
                data.marker.style.left = midway+'px';
            } else {
                data.marker.style.left = pointRight ? `${newPosition.x-pointerdiff}px` : `${newPosition.x+pointerdiff}px`;
            }
            let startx = 15;
            let starty = 15;
            let midx = 15;
            let midy = pointUp ? yoffset+50 : yoffset-50;

            let endx = pointRight ? pointerdiff : -pointerdiff;
            let endy = yoffset;

            if(tracked){
                /*
                const tpointUp = closesty > trackedPosition.y;
                let tyoffset = newPosition.y-closesty;

                startx = 15;
                starty = tpointUp ? tyoffset+50 : tyoffset-50;*/
                endx = newPosition.x - parseInt(tracked.marker.style.left, 10);
                endy = newPosition.y - parseInt(tracked.marker.style.top, 10);
            } else if(midway) {
                endx = newPosition.x - midway;
                //endy = newPosition.y - parseInt(tracked.marker.style.top,10);
            }

            const diff = Math.abs(starty - midy);
            if(diff < 30){
                if(midway){
                    if(!tracked){
                        const adjust = starty > midy ? -30 : 30;
                        data.marker.style.top = `${closesty-adjust}px`;
                    
                        midy += adjust;
                        data.marker.dataset.midy = adjust;
                        endy += adjust;
                    }
                    data.svgline.plot(startx, starty, midx, midy).show(); 
                } else if (tracked && typeof tracked.marker.dataset.midy != 'undefined'){
                    midy += parseInt(tracked.marker.dataset.midy, 10);
                    data.svgline.plot(startx, starty, midx, midy).show(); 
                    
                } else {
                    midx = startx;
                    midy = starty;
                    data.svgline.hide();
                }
            } else {
                if(tracked){
                    starty = starty < midy ? starty + 15 : starty - 15;
                }
                data.svgline.plot(startx, starty, midx, midy).show(); 
            }
            data.svgline2.plot(midx, midy, endx, endy);
            //const xoffset = data.xoffset - (data.marker.offsetWidth/2);
            //const yoffset = data.yoffset - (data.marker.offsetHeight/2);
            //data.marker.style.marginLeft = `${xoffset}px`;  
            //data.marker.style.marginTop = `${yoffset}px`;
        });
    },

    hightlightObject () {
        if (this.highlights.length === 0 || zoomed || this.controls.moving){            
            return;
        }
        this.raycaster.setFromCamera(this.mouse, this.camera);
    
        const intersects = this.raycaster.intersectObjects(this.highlights);

        if (intersects.length > 0) {
            this.tooltip.style.visibility = 'visible';
            
            this.tooltip.style.left = `${this.screen.x + 5}px`;
            this.tooltip.style.top = `${this.screen.y + 5}px`;
            if (this.currentlyIntersected != intersects[0].object) {
                if (this.currentlyIntersected) {
                    //this.currentlyIntersected.material.emissive.setHex(this.currentlyIntersected.currentHex);
                }
                this.currentlyIntersected = intersects[0].object;
                this.outlinePass.selectedObjects = [this.currentlyIntersected];
                //console.log(this.currentlyIntersected);
                this.tooltipText.innerHTML = this.currentlyIntersected.name;
                //this.scene.updateMatrixWorld();
                //const vector = new THREE.Vector3();
                // vector.setFromMatrixPosition( this.currentlyIntersected.matrixWorld );
                //console.log(vector);
                
                
                //this.currentlyIntersected.currentHex = this.currentlyIntersected.material.emissive.getHex();
                //this.currentlyIntersected.material.emissive.setHex(0xba2334);
                //this.currentlyIntersected.material.emissiveIntensity = 0.2;
        
      
                this.tooltipText.innerHTML = this.currentlyIntersected.name;
            }
        } else {
            this.tooltip.style.visibility = 'hidden';
            
            if (this.currentlyIntersected) {
                //this.currentlyIntersected.material.emissive.setHex(this.currentlyIntersected.currentHex);
            }
            this.currentlyIntersected = null;
        }
    },

    render () {
        if (!this.renderer.autoClear) this.renderer.clear();

        this.hightlightObject();

        this.setMarkers();

        this.composer.render();

    },



    vectorToScreen(vector, camera){
        const {width, height} = this.renderer.getContext().canvas;

        const widthHalf = 0.5 * width;
        const heightHalf = 0.5 * height;
        vector.project(camera);

        const x = ( vector.x * widthHalf ) + widthHalf;
        const y = - ( vector.y * heightHalf ) + heightHalf;

        return { 
            x,
            y,
            vectorx: vector.x,
            vectory: vector.y,
        };
    },

    toScreenPosition(object, pointerPosition, camera) {
        const vector = this.getCenterPoint(object, pointerPosition);

        return this.vectorToScreen(vector, camera);
    },
};

window.addEventListener('load', () => {
    const canvasElement = document.querySelector('#room');
    if(!canvasElement){
        return;
    }
    
    const app = new TitonHouse(canvasElement);

    const resizeWindow = function () {
        app.resizeDisplayGL();
    };

    const render = function () {
        requestAnimationFrame(render);
        app.render();
    };

    const onMouseMove = function (event) {
        event.preventDefault();

        app.screen.x = event.clientX;
        app.screen.y = event.clientY;
        app.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        app.mouse.y = - (event.clientY / window.innerHeight) * 2 + 1;
    };

    window.addEventListener('resize', resizeWindow, false);
    document.addEventListener('mousemove', onMouseMove, false);

    app.initGL();
    app.resizeDisplayGL();
    app.initContent();

    render();
});
